<script setup>
// Aviso de massiva aberta na barra superior — em qualquer tela, só pra quem
// tem a aba Massiva. Some quando não há massiva aberta. Clicar leva à aba,
// onde está a caixa/rota afetada; aqui é só o sinal.
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMassivaAlert } from './useMassivaAlert';

const router = useRouter();
const { accountScopedRoute } = useAccount();
const { isVisible, isCritical, isStale, label, tooltip } = useMassivaAlert();

const goToMassiva = () => router.push(accountScopedRoute('studio_massiva'));
</script>

<template>
  <!-- O wrapper existe só pra manter a raiz estável (regra vue/no-root-v-if):
       sem massiva aberta, nada é renderizado dentro. -->
  <span v-if="isVisible" class="contents">
    <button
      v-tooltip="tooltip"
      type="button"
      class="flex items-center gap-2 h-8 px-2.5 rounded-lg outline outline-1 min-w-0 max-w-xs transition-colors"
      :class="
        isCritical
          ? 'bg-n-ruby-3 outline-n-ruby-6 text-n-ruby-11 hover:bg-n-ruby-4'
          : 'bg-n-amber-3 outline-n-amber-6 text-n-amber-11 hover:bg-n-amber-4'
      "
      data-test-id="massiva-alert-chip"
      @click="goToMassiva"
    >
      <span class="relative flex-shrink-0 size-3.5">
        <span class="absolute inset-0 i-lucide-wifi-off" />
        <span
          v-if="isCritical"
          class="absolute -top-0.5 -right-0.5 size-1.5 rounded-full bg-n-ruby-9 motion-safe:animate-ping"
        />
      </span>
      <span class="truncate text-xs font-medium">{{ label }}</span>
      <span
        v-if="isStale"
        class="flex-shrink-0 size-3 i-lucide-cloud-off opacity-70"
      />
    </button>
  </span>
</template>
